import { MeasurementToolsViewModel } from "../../manage-components/manage-components.model";

export class DipTestConditionType {
    public Id: number;
    public Description: string;
}

export class WsreOverview {
    public CustomerName: string;
    public JobsiteName: string;
    public SerialNumber: string;
    public InspectionDate: Date;
    public Make: string;
    public Model: string;
    public LifeLived: number;
    public JobNumber: string;
    public CustomerReference: string;
    public OldJobNumber: string;
    public ReportPrepared: boolean;
    public TrackFrame_Right_SystemId:number;
    public TrackFrame_Left_SystemId:number;
    public TrackFrame_Customer_L_Serial:string;
    public TrackFrame_Customer_R_Serial:string;
    public TrackFrameOverallComment_R:string;
    public TrackFramOverallRecommendation_R:string;  
    public TrackFrame_Left_SystemName:string;
    public TrackFrame_Right_SystemName:string;
    public FrameInspectedSide:number;
    public ToeOutFrameLeft:number;
    public ToeOutFrameRight:number;
    public CastFrameLeft:number;
    public CastFrameRight:number;  
    public CustomerId: number; 
}

export class WsreSummary {
    public OverallEval: string;
    public OverallEval_R:string;
    public OverallComment: string;
    public OverallRecommendation: string;
    public Components: ComponentSummary[];
    public CrackTest: CrackTestSummary;
    public DipTests: DipTestSummary[];
    public TrackFrameOverallComment_R:string
    public TrackFramOverallRecommendation_R:string ;
    public   FrameConfigurationId:number;
    public overallComponentLeft:string;
    public overallComponentRight:string;

}

export class ComponentSummary {
    public Type: string;
    public Recommendations: string[];
    public Comment: string;
    public WornPercentage: number;
}

export class CrackTestSummary {
    public Passed: boolean|null;
    public Comment: string;
}

export class DipTestSummary {
    public Number: number;
    public Problem: string;
    public Colour: string;
    public Comment: string;
}

export class Photo {
    public ImageData: string;
    public Title: string;
    public Comment: string;
}

export class ArrivalPhotoOverview {
    public Id: number;
    public ImageData: string;
    public Type: InitialImageType;
    public Title: string;
    public Comment: string;
    public side:number
    public isMainPhoto:boolean
    public IncludeInReport:boolean
}

export enum InitialImageType {
    OldTag = 1,
    CustomerReference,
    Arrival,
    Final,
    FailedIron,
}

export class ComponentTabRecord {
    public Id: number;
    public WornPercentage: number;
    public Component: string;
    public Brand: string;
    public Cmu: number;
    public RemainingLife: number;
    public Measurement: number;
    public Recommendations: string[];
    public Comment: string;
    public Photos: ComponentPhoto[];
    public MasterLinkPhotos: ComponentPhoto[];
    public PossibleTools: MeasurementToolsViewModel[];
    public Tool:string;
    public ToolId:number;
    public CompartTypeAuto:number;
    public OtherLinks:number|null;
    public NumberRequiringReplacement:number|null;
    public ScallopMeasurment:number|null;
    public RunningSide:number|null;
    public ReverseSide:number|null;
    public ShoeHight:number|null;
    public ShoeWidth:number|null;
    public BushTurned:number|null;
    public ShoeReluggedcca:number|null;
    public Mastershoe:number|null;
    public AllHardwarepresent:number|null;
    public HardwareCondition:number|null;
    public MasterLinkCrack:number|null;
    
    
    public MasterLinkToothCount:number|null;

    public OtherLinkCrack:number|null;
    public BushCrack:number|null;
    public ShoeCrack:number|null;
    public BrokenBoltRHPE:number|null;
    public BrokenBoltLHPE:number|null;
    public MasterLinkRHPE:number|null;
    public MasterLinkLHPE:number|null;
    public MasterLinkRHBE:number|null;
    public MasterLinkLHBE:number|null;

    public Idlr_Dia_A_New:number|null;
    public Idlr_Dia_A_100prc:number|null;
    public Idlr_Dia_B_New:number|null;
    public Idlr_Dia_B_100prc:number|null;
    public Idlr_WidthOfCG_New:number|null;
    public Idlr_ShaftOTR:number|null;
    public Idlr_Measure_in_to_150_1:number|null;
    public Idlr_Measure_in_to_150_2:number|null;
    public Idlr_No_1_side_NS_Face:number|null;
    public Idlr_No_1_side_NS_Middle:number|null;
    public Idlr_No_1_side_NS_Centre:number|null;
    public Idlr_No_1_side_ES_Face:number|null;
    public Idlr_No_1_side_ES_Middle:number|null;
    public Idlr_No_1_side_ES_Centre:number|null;
    public Idlr_No_2_side_NS_Face :number|null;
    public Idlr_No_2_side_NS_Middle :number|null;
    public Idlr_No_2_side_NS_Centre :number|null;
    public Idlr_No_2_side_ES_Face :number|null;
    public Idlr_No_2_side_ES_Middle :number|null;
    public Idlr_No_2_side_ES_Centre :number|null;

    public Idlr_No_1_side_NS_Face_BIM:number|null;
    public Idlr_No_1_side_NS_Middle_BIM:number|null;
    public Idlr_No_1_side_NS_Centre_BIM:number|null;
    public Idlr_No_1_side_ES_Face_BIM:number|null;
    public Idlr_No_1_side_ES_Middle_BIM:number|null;
    public Idlr_No_1_side_ES_Centre_BIM:number|null;
    public Idlr_No_2_side_NS_Face_BIM :number|null;
    public Idlr_No_2_side_NS_Middle_BIM :number|null;
    public Idlr_No_2_side_NS_Centre_BIM :number|null;
    public Idlr_No_2_side_ES_Face_BIM :number|null;
    public Idlr_No_2_side_ES_Middle_BIM :number|null;
    public Idlr_No_2_side_ES_Centre_BIM :number|null;

    

    public Idlr_No_1_side_NS_Face_after:number|null;
    public Idlr_No_1_side_NS_Middle_after:number|null;
    public Idlr_No_1_side_NS_Centre_after:number|null;
    public Idlr_No_1_side_ES_Face_after:number|null;
    public Idlr_No_1_side_ES_Middle_after:number|null;
    public Idlr_No_1_side_ES_Centre_after:number|null;
    public Idlr_No_2_side_NS_Face_after :number|null;
    public Idlr_No_2_side_NS_Middle_after :number|null;
    public Idlr_No_2_side_NS_Centre_after :number|null;
    public Idlr_No_2_side_ES_Face_after :number|null;
    public Idlr_No_2_side_ES_Middle_after :number|null;
    public Idlr_No_2_side_ES_Centre_after :number|null;

    public Idlr_No_1_side_retainer :number|null;
    public Idlr_No_1_side_collar :number|null;
    public Idlr_No_1_side_thrust:number|null;
    public Idlr_No_2_side_retainer:number|null;
    public Idlr_No_2_side_collar:number|null;
    public Idlr_No_2_side_thrust:number|null;
    public Idlr_No_2_side_bolts :number|null;
    public Idlr_No_2_side_washers:number|null;
    public SystemId:number=0;
    public CompartId: number;
    public MasterLink: number;
    public JobNumber: string;
    public AssetNumber: string;
    public BushTurnedBudgetLife: number;
    public BushTurnedPercent: number;
    public BudgetLife: number;
    public ShoeSize: number;
    public GrouserId: number;
    public CleanerHolesId: number;
    public MLink: number;
    public ComponentId: number;
    public MakeId: number;
}

export class ComponentPhoto {
    public Id: number;
    public ImageData: string;
    public Title: string;
}

export class CrackTestTab {
    public TestPassed: boolean;
    public Comment: string;
    public Photos: ComponentPhoto[];
}

export class DipTest {
    public Id: number;
    public Number: number;
    public Level: number;
    public Condition: string;
    public Colour: string;
    public Comment: string;
    public Recommendation: string;
    public Photos: ComponentPhoto[];
}

export class CreateDipTestsVM{
    public dipTestNum:number;
    public WSREId:number;
}



export class SaveNewPhotoOnComponentWSREModelRequest {
  public ComponentRecordId: number;
  public PhotoData: string;
  public ComponentImageTypeId?: number;

  /**
   *
   */
  constructor(id: number, data: string, typeId? :number) {
    this.ComponentRecordId = id;
    this.PhotoData = data;
    this.ComponentImageTypeId = typeId;
  }
}

export class IdlerPartImageReqVM{
    public ComponentRecordID: number;
    public PartId: number;
    public PhotoData: string;
}



export class SaveNewPhotoOnDipTestWSREModelRequest  {
  public DipTestId: number;
  public PhotoData: string;

  /**
   *
   */
  constructor(id: number, data: string) {
    this.DipTestId = id;
    this.PhotoData = data;
  }
}

export class SaveNewPhotoFrameWSREModelRequest  {
    public Id: number;
    public PhotoData: string;
    public side:number;
  
    /**
     *
     */
    constructor(id: number, data: string, side:number) {
      this.Id = id;
      this.PhotoData = data;
      this.side=side;
    }
  }

  export class componentTabFrames{
    public Id:number
    public WSREType:number
    public measurementPointName:string
    public CompartMeasurementPoints: WsreCompartMeasurementPoints[];
    public isShowMeasurementPoints:boolean
    public comment_L:string
    public comment_R:string
    public  ImageData:string
    public WSREFrameCrackRecordsVM: WSREFrameCrackRecordsVM[];

    public DocumnetData :string;
    public FileName:string;
   
  }

  export class WsreCompartMeasurementPoints {
    public Id: number
    public Id_R: number
    public compartId:number
    public compartName:string
    public Measurement:number
    public spec:number
    public range:number
    public Measurement_RIGHT:number
    public isWithinTheRangeLeftMeasurement:boolean
    public isWithinTheRangeRightMeasurement:boolean
    public ToolId :number
    public IsOk_L:boolean;
    public IsOk_R:boolean;

    public PhotoThumbnail_L:string;
    public PhotoThumbnail_R:string;
    public PhotoThumbnail_L_Final:string;
    public PhotoThumbnail_R_Final:string;

    public PhotoId_L:string;
    public PhotoId_R:string;
    public FinalMeasurement_L:number;
    public FinalMeasurement_R:number;
    public ToleranceType: string;
}

export class WSREFrameComponentsRecordsVM{
    public measurementPointName:string
    public Id:number
    public WSREInspectionID:number
    public ComponentId:number
    public measurement:number
    public MeasurementPointId:number
    public side:number
    public WSREMeasurementType:number
    public MeasurementIsOk:boolean;
    public ScreenId:number;
    }

    export class ComponentCrackImagesFrame{
        public  Id:number
        public  WSREInspectionID:number
        public  WSREMeasurementPointId:number      
        public  isCrackImage:boolean
        public  Image:string
        public  side:number

         /**
     *
     */
    constructor( WSREInspectionID: number, WSREMeasurementPointId:number, isCrackImage:boolean,
        Image:string, side:number
        
        ) {
        
        this.WSREInspectionID = WSREInspectionID;
        this.WSREMeasurementPointId=WSREMeasurementPointId;
        this.isCrackImage=isCrackImage;
        this.Image=Image;
        this.side=side;

      }
    }

    export class ComponentFrameComment{
        public  Id:number
        public  WSREInspectionID:number
        public  WSREMeasurementPointId:number   
        public comment:string
        public  side:number
        public ScreenId:number
    }

 
    export class MeasurementCrackImagesFrame{
        public  Id:number
        public  WSRECrackID:number      
        public  Image:string
        public isFinalCrackImag :number

         /**
     *
     */
    constructor( WSRECrackID: number, 
        Image:string
        
        ) {
        
        this.WSRECrackID = WSRECrackID;      
        this.Image=Image;
      

      }
    }
export class WSREFrameCrackRecordsVM {
    public Id:number
    public WSREInspectionID:number
    public WSREMeasurementPointId:number
    public comment:string
    public name:string
    public side :number
    public CrackLength :number
    public WsreComponentTabPhotoVM:WsreComponentTabPhoto[]
}

export class WsreComponentTabPhoto
{
    public  Id:number
    public  ImageData:string
    public IsCrackFinalImage :boolean
   
}

export interface WSREActionHistoryVM {
  ActionDate: Date;
  ActionId: number;
  Comment: string;
  Cost: number;
  ActionDescription: string;
  ComponentName: string;
  HistoryId: number;
  CmuExisting: number;
  CmuNew: number;
  WornExisting: number;
  WornNew: number;
  OldValue: string;
  NewValue: string;
  EnteredBy: string;
  Screen: string;
  ScreenLink: string;
}

export interface PagedResult<T> {
  TotalRecords: number;
  Data: T[];
}
